class FormValidation{

	noop() {

	}

    constructor($form, __options){

		this.$form = $form;
        if(this.$form.data('form')) return;

		/*
		 * Binding functions
		 *
		 */

		this.noop = this.noop.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onToggleInputs = this.onToggleInputs.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.validate = this.validate.bind(this);
        this.inputFile = this.inputFile.bind(this);

		/*
		 * Default options
		 *
		 */

		const defaultOptions = {
			ajax: false,
			onSubmit: this.noop,
			onSuccess: this.noop,
			onError: this.noop,
			fileTypeAccepted: new RegExp("(.*?)\.(docx|doc|pdf)$"),
			emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			inputClass: 'Input__Wrap',
			inputFocusClass: 'Input--focused',
			inputNotValidClass: 'Input--not-valid',
			submitButtonSelector: '.Form__Submit',
			formSendingClass: 'Form--sending',
			contentType: 'application/json; charset=utf-8',

		}

		this.options = Object.assign(defaultOptions, __options);

		/*
		 * Initializing variables
		 *
		 */

        this.$response = this.$form.find('.Form__Response');
        this.$inputs = this.$form.find('input, select, textarea');
        this.$requireds = this.$inputs.filter('[required], [data-test]');
        this.$inputFilter = this.$requireds.filter('[data-input-filter]');
        this.$togglers = this.$inputs.filter('[data-form-toggle-type]')
        this.$submitButton = this.$form.find(this.options.submitButtonSelector);
        this.$robotField = this.$inputs.filter('[data-test]');

		/*
		 * Bind events
		 *
		 */

        this.$inputs.on('focusin focusout', this.onFocus)
        this.$togglers.on('change', this.onToggleInputs)

        this.$form.attr('novalidate', true);
        this.$form.on('submit', this.onSubmit);

        this.$inputs.on('keydown', this.validate);
        this.$inputs.filter('[type="file"]').on('change', this.inputFile);

    }

    inputFile(e){

        let $field = $(e.target);
        let fieldName = $field[0].files[0].name;
        $field.closest('.InputFile').find('span').text(fieldName.length > 10 ? fieldName.substring(0, 10) + '...' : fieldName);

    }

    onFocus(e){

        let $field = $(e.currentTarget),
            $wrap = $field.closest(`.${this.options.inputClass}`);

        if(e.type == 'focusin' && $wrap.length)
            $wrap.addClass(this.options.inputFocusClass);
        else if($wrap.length && $field.val().trim() == '')
            $wrap.removeClass(this.options.inputFocusClass);

    }

    onToggleInputs(e){

        let $field = $(e.currentTarget),
            value = $field.val();

        if(value == 'jobs')
            this.$form.find('.input-jobs').show();
        else
            this.$form.find('.input-jobs').hide();

    }

    validate(input){

        let $input;
        if(input.target)
            $input = $(input.currentTarget);
        else
            $input = $(input);

        let isTest = $input.data('test');
        let type = $input.is('textarea') ? 'textarea' : ($input.is('input') ? $input.attr('type') : 'select'),
            value = $input.val().trim();

        if(
            ((type == 'textarea' || type == 'text') && value == '') ||
            (type == 'select' && $input.find('option:selected').length == 0) ||
            (type == 'checkbox' && !$input.is(':checked')) ||
            (type == 'email' && !this.options.emailRegex.test(value))
        ){

            $input.closest(`.${this.options.inputClass}`).addClass(this.options.inputNotValidClass);
            $input.on('change', this.validate);

        }else{

            $input.closest(`.${this.options.inputClass}`).removeClass(this.options.inputNotValidClass);
            $input.off('change', this.validate);

        }

    }

    onSubmit(e){

        e.preventDefault();

        // this.$requireds.each((index, item) => {
        //     this.validate(item);
        // })

        //if(!this.$form.find(`.${this.options.inputNotValidClass}`).length){

            let serializedData = this.$form.serialize(),
                serializedDataArray = this.$form.serializeArray(),
                $inputFile = this.$form.find('input[type=file]'),
                contentType = this.options.contentType,
                formAction = this.$form.attr('action'),
                processData = true,
                postData;

			/*

            if(formType == 'jobs'){

                formAction = '/handlers/FormHandler.ashx';
                let formData = new FormData();
                contentType = false;
                processData = false;

                serializedArray.forEach((a, b) => {
                    formData.append(a.name, a.value);
                })
                if($inputFile.length && $inputFile[0].files.length){

                    let file = $inputFile[0].files[0];
                    if(this.fileTypeAccepted.test(file.name))
                        formData.append('file', $inputFile[0].files[0]);
                    else
                        console.log('Formato non accettato');

                }
                postData = formData

            }else{

                postData = "{ data: '" + serialized + "' }";

            }

            if(this.$form.find('[name="tipologia"]').length){
                dataLayer.push({
                    'event':'standardEvent',
                    'eventCategory':'Contact Form' ,
                    'eventAction':'Submit',
                    'eventLabel': this.$form.find('[name="tipologia"] option:selected').text()
                });
            }else if(this.$form.find('[name="country"]').length){
                dataLayer.push({
                    'event':'standardEvent',
                    'eventCategory':'Newsletter Form',
                    'eventAction':'Submit',
                    'eventLabel': this.$form.find('[name="country"]').val()
                });
            }

            $.ajax({
                type: 'POST',
                url: formAction,
                data: postData,
                // processData: processData,
                contentType: contentType,
                dataType: 'json',
                success: (data) => {

                    // if(data.d == 'OK'){
                    //     this.$response.addClass('show');
                    //     this.$response.removeClass('error');
                    //     this.$submitButton.prop('disabled',false);
                    //     this.$submitButton.removeClass(this.options.formSendingClass);
                    // }else{
                    //     this.$response.addClass('show');
                    //     this.$response.addClass('error');
                    //     this.$submitButton.prop('disabled',false);
                    //     this.$submitButton.removeClass(this.options.formSendingClass);
                    // }
                    //
                    // this.$form[0].reset();
                    //
                    // setTimeout(() => {
                    //     this.$response.removeClass('show');
                    //     this.$response.removeClass('error');
                    // }, 3000)

                },
                error: (xhr, status, error) => {

                    // this.$response.addClass('show');
                    // this.$response.addClass('error');
                    // this.$submitButton.prop('disabled',false);
                    // this.$submitButton.removeClass(this.options.formSendingClass);
                    // this.$form[0].reset();
                    //
                    // setTimeout(() => {
                    //     this.$response.removeClass('show');
                    //     this.$response.removeClass('error');
                    // }, 5000)

                }

            });

			*/

			this.options.onSubmit();

            $.post(this.$form.attr('action'), serializedData, (data) => {

				this.options.onSuccess(data);

				setTimeout(() => {
					this.$form[0].reset();
				}, 4000);

            }).fail((data) => {

				this.options.onError(data);

            });

        //}

    }

}

export default FormValidation;



// WEBPACK FOOTER //
// ./js/components/FormValidation.js